import { render } from "./Label.vue?vue&type=template&id=7807e794&bindings={\"help\":\"props\"}"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
script.render = render

export default script